import { gql } from '@apollo/client';
import {
  DTOOLS_AUTH_DETAILS_FRAGMENT,
  DTOOLS_PROJECT_IMPORT_DETAILS,
} from './dtools.fragments';

export const DTOOLS_AUTHENTICATE = gql`
  mutation DtoolsAuthenticate($params: DtoolsAuthenticateInput!) {
    dtoolsAuthenticate(params: $params) {
      authDetails {
        id
        ...DtoolsAuthDetails
      }
    }
  }
  ${DTOOLS_AUTH_DETAILS_FRAGMENT}
`;

export const DTOOLS_REVOKE_AUTHENTICATION = gql`
  mutation DtoolsRevokeAuthentication($params: DtoolsRevokeAuthenticationInput!) {
    dtoolsRevokeAuthentication(params: $params) {
      partnerId
    }
  }
`;

export const GET_DTOOLS_AUTH_DETAILS = gql`
  query GetDtoolsAuthConnections($params: GetDtoolsAuthDetailsInput!) {
    getDtoolsAuthDetails(params: $params) {
      authDetails {
        id
        ...DtoolsAuthDetails
      }
    }
  }
  ${DTOOLS_AUTH_DETAILS_FRAGMENT}
`;

export const GET_DTOOLS_PROJECTS = gql`
  query GetDtoolsProjects($params: GetDtoolsProjectsInput!) {
    getDtoolsProjects(params: $params) {
      projects {
        id
        name
        number
        clientName
        createdDate
        modifiedDate
      }
      totalProjects
    }
  }
`;

export const GET_DTOOLS_PROJECT_DETAILS = gql`
  query GetDtoolsProjectDetails($params: GetDtoolsProjectDetailsInput!) {
    getDtoolsProjectDetails(params: $params) {
      content
    }
  }
`;

export const GET_DTOOLS_PROJECT_IMPORT_PREVIEW = gql`
  query GetDtoolsProjectImportPreview($params: ImportDtoolsProjectInput!) {
    getDtoolsProjectImportPreview(params: $params) {
      records {
        ...DtoolsProjectImportDetails
      }
      errors {
        projectId
        error
      }
    }
  }
  ${DTOOLS_PROJECT_IMPORT_DETAILS}
`;

export const IMPORT_DTOOLS_PROJECT = gql`
  mutation ImportDtoolsProject($params: ImportDtoolsProjectInput!) {
    importDtoolsProject(params: $params) {
      records {
        ...DtoolsProjectImportDetails
      }
      errors {
        projectId
        error
      }
    }
  }
  ${DTOOLS_PROJECT_IMPORT_DETAILS}
`;
